import React, { useContext } from "react";
import { FaFirstAid, FaBullhorn, FaUsers, FaMapMarkedAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./emerg.jpg";

const Emergency: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/emergency-preparedness');
    } else {
      navigate('/login', { state: { from: '/booking/emergency-preparedness' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Preparedness</span>
          <h1 className="hero-title">Emergency Management</h1>
          <p className="hero-subtitle">
            When seconds count, a plan makes the difference. Evacuation protocols,
            assembly points, and crisis communication.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Emergency Plan</h2>
              <p className="article-text">
                Hope is not a strategy. Every facility must have a written Emergency Action Plan (EAP).
                It covers: Reporting fires/emergencies, Evacuation procedures, Critical shutdown duties,
                and Assemble & Headcount protocols.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Drills & Training</h2>
              <p className="article-text">
                Panic causes more casualties than the hazard itself. Regular drills program muscle memory.
                <br /><strong>Fire Drill:</strong> Speed and routes.
                <br /><strong>Shelter-in-Place:</strong> Chemical release or weather.
                <br /><strong>Medical Drill:</strong> First aid response times.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Roles & Responsibilities</h2>
              <p className="article-text">
                <ul style={{ paddingLeft: '20px', color: '#ccc', lineHeight: '1.8' }}>
                  <li><strong>Incident Commander:</strong> Makes critical decisions.</li>
                  <li><strong>Fire Wardens:</strong> Sweep areas and guide evacuation.</li>
                  <li><strong>First Aiders:</strong> Triage and treat injuries.</li>
                  <li><strong>Employees:</strong> Shut down equipment and evacuate calmly.</li>
                </ul>
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">During Alarm</h4>
              <ul className="key-list">
                <li><FaBullhorn className="check-icon" /> Stop Work Immediately</li>
                <li><FaMapMarkedAlt className="check-icon" /> Follow Green Signs</li>
                <li><FaUsers className="check-icon" /> Go to Assembly Point</li>
                <li><FaFirstAid className="check-icon" /> Report Missing Persons</li>
              </ul>
            </div>
            <div className="sidebar-widget">
              <h4 className="widget-title">Don't be a hero</h4>
              <p style={{ color: '#aaa', lineHeight: '1.6', fontSize: '0.9rem' }}>
                Do not re-enter the building until the "All Clear" is given by the Incident Commander.
                Personal items can be replaced; you cannot.
              </p>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Be Prepared</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Ensure your team knows exactly what to do.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Emergency;
